const modifyDataForReactSelect = (objectArray) =>
  objectArray.map((singleObject) => ({
    ...singleObject,
    value: singleObject.id,
    label: singleObject.name,
  }));

export default modifyDataForReactSelect;
